import rightArrow from "../../assets/img/arrow-right.svg"
import freePlan from "../../assets/img/free_plan.svg"
import regular from "../../assets/img/regular.svg"
import silver from "../../assets/img/silver.svg"
import gold from "../../assets/img/gold.svg"
import { useEffect, useState } from "react"
import { CallWithAuth, CallWithOutAuth } from "../../action/apiActions"
import { GET_SUBSCRIPTION, INIT_SUBSCRIPTION } from "../../action/apiPath"
import { toast, ToastContainer } from "react-toastify"
import { loadStripe } from "@stripe/stripe-js"
import { Link, useNavigate } from "react-router-dom"
import { showToast } from "../../util/toastHelper"

export const SubscriptionPage = () => {

    const subscription_id = localStorage.getItem("subscription_id")
    const [subscriptionDetail, setSubscriptionDetail] = useState([]);
    const navigate = useNavigate()
    const [userDetail , setUserDetail] = useState({});
    const [paymentInit, setPaymentInit] = useState(false);

    const subscriptionList = async () => {
        try {
            const response = await CallWithAuth('GET', GET_SUBSCRIPTION)
            console.log(response)
            if (response.res.status == 200) {
                // toast.dismiss();
                showToast("success", response.res.data.message);
                // toast.success(response.res.data.message, {
                //     autoClose: 2000,
                //     position: "bottom-right",
                // })
                // setSubscriptionDetail(response.res.data.data)
                 const data = response.res.data.data;
                 setSubscriptionDetail(Array.isArray(data) ? data : []);
            } else {
                showToast("error", response.res.data.message);
                  setSubscriptionDetail([]);
                // toast.error(response.res.data.message, {
                //     autoClose: 2000,
                //     position: "bottom-right",
                // })
            }
        } catch (err) {
            showToast("error", err);
             setSubscriptionDetail([]);
            // toast.error(err, {
            //     autoClose: 2000,
            //     position: "bottom-right",
            // })
        }
    }

    useEffect(() => {
        subscriptionList()
        //get current subscription details
        setUserDetail(localStorage?.getItem("userCreateAccount") ? JSON.parse(localStorage?.getItem("userCreateAccount")) : {})
    }, [])
    // console.log('userDetail',userDetail);
    


    const [selectedID, setSelectedID] = useState(null)

    const Selectsubscription = (planId) => {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
            navigate("/login");
        }
        
        const subscriptionEndDate = userDetail?.subscription?.subscription_enddate
            ? new Date(userDetail.subscription.subscription_enddate)
            : null;

        const today = new Date();

        const isUserSubscribed = !!userDetail?.isSubscribe;
        const isSubscribed = subscription_id === planId; // is this the current active subscription
        const hasSubscriptionEnded = subscriptionEndDate ? subscriptionEndDate < today : false;

        // Prevent selecting the *same active plan*
        if (isUserSubscribed && isSubscribed && !hasSubscriptionEnded) {
            setSelectedID(null);
            return toast.warn("You are already subscribed to this plan.", {
                autoClose: 2000,
                position: "bottom-right",
            });
        }

        // Otherwise allow selection
        setSelectedID(planId);console.log(planId)
    };

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const isTokenAvailable = localStorage.getItem('accessToken')
        if (isTokenAvailable) {
            setIsLoggedIn(true)
        } else {
            setIsLoggedIn(false)
        }
    }, []);



    const MakePayment = async () => {
        if(!isLoggedIn){
           setTimeout(() => {
                navigate('/login')
            },1500)
            return toast.warn("Please Login to buy subscription plan.", {
                autoClose: 2000,
                position: "bottom-right",
            })
        }

        if (selectedID == null) {
            toast.warn("Select any subscription plan.", {
                autoClose: 2000,
                position: "bottom-right",
            })
        } else {          
            if (paymentInit) {
                return;
            }   
            try {
                setPaymentInit(true);
                const body = {
                    "subscription_id": selectedID
                }
                const response = await CallWithAuth('POST', INIT_SUBSCRIPTION, body)
                if (response.res.status == 200 || response.res.status == 201) {
                    StripeCall(response.res.data.data.session_id)
                    // setSubscriptionDetail(response.res.data.data)
                    toast.success(response.res.data.message, {
                        autoClose: 2000,
                        position: "bottom-right",
                    })
                } else {
                   return toast.error(response.res.data.message, {
                    autoClose: 2000,
                    position: "bottom-right",
                })
                }
              
            } catch (err) {
                toast.error(err, {
                    autoClose: 2000,
                    position: "bottom-right",
                })
            } finally {
                setPaymentInit(false);
            }
        }

    }


    const StripeCall = async (e) => {
        const stripe = await loadStripe('pk_test_51Q0bpAGzDnn7G9w0Z6Ox8g3nqjJBbXbQviAEKB0db5a20p839XKpGvwiImqSMJWNc0bQsSivsDXxzwLU9VXVx7qN00dezUw73V')

        const result = stripe.redirectToCheckout({
            sessionId: e
        });

        console.log("==========result", result)

        if (result.error) {
            toast.error(result.error, {
                autoClose: 2000,
                position: "bottom-right",
            })
            console.log(result.error)
        }
    }


    const getPlanDetails = (planName) => {
        let planClass = "";
        let planImage = null;
        let additionalContent = null;

        if (planName === "Regular Plan") {
            planClass = "regular_plan";
            planImage = regular; // Assuming you have imported the 'regular' image
        } else if (planName === "Gold Plan") {
            planClass = "gold_plan";
            planImage = gold; // Assuming you have imported the 'gold' image
        } else if (planName === "Silver Plan") {
            planClass = "silver_plan";
            planImage = silver; // Assuming you have imported the 'silver' image

            // Add additional content for Silver Plan
            additionalContent = <span class="tag">Most Popular</span>;
        }

        return { planClass, planImage, additionalContent };
    };

    return (
        <>
            <section class="create_account_block">
                <div class="site_container">
                    <div className="all_steps">
                        <div class="step_block">
                            <span class="active"></span>
                            <span class="active"></span>
                        </div>
                        <div class="site_row btn_block">
                            <Link to={'/'} class="back_btn"><img src={rightArrow} alt="" /> <span>Back</span></Link>
                            <div class="btn_row">
                                <Link to={'/'} class="outlined_cta cta_outline cta_with_icon"><span>Close</span> </Link>
                                <a onClick={() => MakePayment()} class="solid_cta cta_primary cta_with_icon"><span>Payment Now</span> <img
                                    src={rightArrow} alt="" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="heading_block">
                        <span class="tag">Account Setup</span>
                        <h1>Choose Subscription</h1>
                        <p>Choose the subscription tier that suits your needs and budget</p>
                    </div>
                    <div class="plan_packages">


                        {/* {subscriptionDetail?.map((items, i) => {
                            const { planClass, planImage, additionalContent } = getPlanDetails(items.name);
                            const isSubscribed = subscription_id === items.id; // Check if the subscription_id matches
                            return (
                                <div class={`pkg_item ${planClass}`} key={items.id}>
                                    
                                    {additionalContent}

                                    <div class="pkg_header">
                                        <div class="icon_block">
                                            <img src={planImage} alt="" />
                                        </div>
                                        <h5>{items.name}</h5>
                                        <div class="plan_price">
                                            <h6><sup>$</sup>{items.price}<sub>/mo</sub></h6>
                                        </div>
                                    </div>

                                    <div class="pkg_body">
                                        <span class="txt">Includes</span>
                                        <div dangerouslySetInnerHTML={{ __html: items.description }} />

                                        <div class="plan_select_check"  onClick={!isSubscribed ? () => Selectsubscription(items.id) : undefined}>
                                            <input type="radio" name="plan" />
                                            <div class="check_ui">
                                                <span>{isSubscribed ? "Already subscribed" : (items.id === selectedID ? "Selected" : "Select this plan")}</span>
                                                {!isSubscribed ? <img src={rightArrow} alt="" /> : null }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })} */}
                        {subscriptionDetail?.map((items) => {
                            const { planClass, planImage, additionalContent } = getPlanDetails(items.name);

                            const subscriptionEndDate = userDetail?.subscription?.subscription_enddate
                                ? new Date(userDetail.subscription.subscription_enddate)
                                : null;

                            const today = new Date();

                            const isUserSubscribed = userDetail?.isSubscribe;
                            const isSubscribed = subscription_id === items.id; // is this the current active subscription
                            const hasSubscriptionEnded = subscriptionEndDate ? subscriptionEndDate < today : false;
                            // -----------------
                            // Decide message
                            // -----------------
                            let message = "";
                            if (userDetail?.subscription?.subscription_enddate) {
                                if (isSubscribed && !hasSubscriptionEnded) {
                                    message = "Already subscribed";
                                } else if (isSubscribed && hasSubscriptionEnded) {
                                    message = "Renew subscription";
                                } else if (selectedID === items.id) {
                                    message = "Selected";
                                } else {
                                    message = "Select this plan";
                                }
                            } else {
                                // no subscription yet
                                message = selectedID === items.id ? "Selected" : "Select this plan";
                            }
                            // -----------------
                            // Checked logic
                            // -----------------
                            const isChecked = selectedID === items.id; // user clicked one

                            return (
                                <div className={`pkg_item ${planClass}`} key={items.id}>
                                {additionalContent}

                                <div className="pkg_header">
                                    <div className="icon_block">
                                    <img src={planImage} alt="" />
                                    </div>
                                    <h5>{items.name}</h5>
                                    <div className="plan_price">
                                    <h6>
                                        <sup>$</sup>
                                        {items.price}
                                        <sub>/mo</sub>
                                    </h6>
                                    </div>
                                </div>

                                <div className="pkg_body">
                                    <span className="txt">Includes</span>
                                    <div dangerouslySetInnerHTML={{ __html: items.description }} />

                                    <div
                                    className="plan_select_check"
                                    // onClick={canSelect || (subscription_id !== items.id) ? () => Selectsubscription(items.id) : undefined}
                                    // onClick={Selectsubscription(items.id)}
                                    onClick={() => Selectsubscription(items.id)}

                                    >
                                    <input type="radio" name="plan" checked={isChecked}  />
                                    <div className="check_ui">
                                        <span>{message}</span>
                                        {message === "Select this plan" || message === "Selected" ? (
                                        <img src={rightArrow} alt="" />
                                        ) : null}
                                    </div>
                                    </div>
                                </div>
                                </div>
                            );
                            })}




                    </div>
                </div>
            </section>

            {/* <ToastContainer /> */}

        </>
    )
}